import { errorToastify, successToastify } from "../utils/Toastify";
import { APIsInstance, APIsInstanceUniqeCurrencyId, authInstance } from "./httpService";

// USER INFO
export const getUserInfo = async (userInfo) => {
    const data = await authInstance.post(`/login`, {
        userInfo
    });
    // { headers: { 'content-type': 'application/json', authorization: ''}}
    return data;
};
export const logOutUser = async (userInfo) => {
    const data = await authInstance.post(`/logout`, {
        userInfo
    });
    // { headers: { 'content-type': 'application/json', authorization: ''}}
    return data;
};
export const getUserBinanceAccountInfo = async () => {
    const { data } = await APIsInstance.post(`/getUserBinanceAccountInfo`, {});
    return data;
};
export const getAllOrders = async () => {
    const { data } = await APIsInstance.post(`/allOrders`, {});
    return data;
};

// APIs
export const updateCurrentSide = async (currentSide) => {
    const data = await APIsInstance.post(`/updateCurrentSide`, {
        currentSide
    });
    return data;
};

export const exitMarket = async ({
    currencyId,
    side,
    qty,
    margin,
    leverage,
    strategyType,
    storeInDb,
    binanceMode
}) =>
    await APIsInstanceUniqeCurrencyId.post(`/exitMarket`, {
        currencyId,
        side,
        qty,
        margin,
        leverage,
        strategyType,
        storeInDb,
        binanceMode
    });

export const getChartSettings = async () => await APIsInstance.post(`/chartSettings`, {});
export const getInitialCurrenciesSettings = async () =>
    await APIsInstance.post(`/initialCurrenciesSettings`, {});
export const updateSettings = async ({ side, updatedData }) =>
    await APIsInstance.post(`/updateSettings`, {
        side,
        updatedData
    });
export const updateChartDataFormat = async ({ isChartDataFormatRenko }) =>
    await APIsInstance.post(`/updateChartDataFormat`, {
        isChartDataFormatRenko
    });

export const updateAMI = async ({ valueObject }) =>
    await APIsInstance.post(`/updateAMI`, {
        valueObject
    });
export const updateWalletConfiguration = async ({ side, walletData }) =>
    await APIsInstance.post(`/updateWalletConfiguration`, {
        side,
        walletData
    });
export const toggleCreateRenko = async ({
    isRenkoCreationOn,
    walletConfig,
    isChartDataFormatRenko
}) => {
    return await APIsInstance.post(`/toggleCreateRenko`, {
        renkoStatus: isRenkoCreationOn,
        walletConfig,
        isChartDataFormatRenko
    });
};
export const toggleModel = async ({
    isModelOn,
    approachId,
    methodId,
    interestId,
    walletConfig
}) => {
    return await APIsInstance.post(`/toggleModel`, {
        isModelOn,
        approachId,
        methodId,
        interestId,
        walletConfig
    });
};
export const toggleBinance = async ({
    isBinanceOn,
    approachId,
    configData,
    binanceMode,
    methodId
}) => {
    return await APIsInstance.post(`/toggleBinance`, {
        isBinanceOn,
        approachId,
        walletConfig: configData,
        binanceMode,
        methodId
    });
};
export const toggleTradeMode = async ({ isBinanceOn, approachId, binanceMode, methodId }) => {
    return await APIsInstance.post(`/toggleTradeMode`, {
        approachId,
        binanceMode,
        methodId
    });
};

export const getTransactionsDetails = async ({ side, page, sort, type }) => {
    return await APIsInstance.post(`/getTransactionsDetails`, {
        side,
        page,
        sort,
        type
    });
};

export const getChartDataFinalRange = async (isChartDataFormatRenko) => {
    try {
        const data = await APIsInstance.post(`/getChartDataFinalRange`, {
            isChartDataFormatRenko
        });
        return data;
    } catch (error) {
        errorToastify(error);
        return {};
    }
};

export const getChartDateByDate = async ({ selectedDate, isChartDataFormatRenko }) =>
    await APIsInstance.post(`/getChartDataSinceSpecificTime`, {
        selectedDate,
        isChartDataFormatRenko
    });
export const getChartDataRange = async ({ rowIdIndex, rangeDirection, isChartDataFormatRenko }) =>
    await APIsInstance.post(`/getChartDataRange`, {
        rowIdIndex,
        rangeDirection,
        isChartDataFormatRenko
    });

export const getAllTransactionsData = async ({ transactionType }) =>
    await APIsInstance.post(`/getAllTransactionsData`, {
        transactionType
    });

// PROGRAMS STATUS APIS
export const stopRunningProg = async (progId) => {
    try {
        const { data } = await APIsInstance.post(`/stopRunningProg`, {
            progId
        });
        successToastify(data?.message || "App restart; refresh the page.");
    } catch (error) {
        errorToastify("Please refresh the page!");
    }
};
